import { List, Record } from "immutable";

import { ContentType } from "@seneca/course-service-types";

export type SectionId = string;
type CourseId = string;
type ContentId = string;
type ModuleId = string;
export type SectionContent = { id: ContentId; contentType: ContentType };

export type SectionType = {
  id?: SectionId;
  parentId: (SectionId | CourseId) | null | undefined;
  title?: string;
  number?: number;
  description?: string;
  sectionIds: List<SectionId>;
  contentIds: List<ContentId>;
  exerciseContentIds: List<ContentId>;
  moduleIds: List<ModuleId>;
  examQuestionsCount?: number;
  hasSequentialContent?: boolean;
  hasHardestQuestionContent?: boolean;
};

export type OptionalSectionType = Partial<SectionType>;

const defaultSection: SectionType = {
  id: undefined,
  parentId: undefined,
  title: undefined,
  description: undefined,
  number: undefined,
  sectionIds: List(),
  contentIds: List(),
  exerciseContentIds: List(),
  moduleIds: List(),
  examQuestionsCount: undefined,
  hasSequentialContent: undefined,
  hasHardestQuestionContent: undefined
};

export default class Section extends Record(defaultSection) {}
